<div class="lookupfilter-body" [ngClass]="{ 'beta-access-enabled': isBetaAccessPrivilegeConsumable }">
  <div class="spinner-container" *ngIf="isLoading">
    <p-progress-spinner></p-progress-spinner>
  </div>
  <div class="section-table-container lookup-tbl page-variables">
    <div>
      <div class="section-table-container page-variables-table">
        <div class="outer-border">
          <button
            type="button"
            class="btn btn-primary btn-sm px-3"
            [ngClass]="{ 'button-filled': isBetaAccessPrivilegeConsumable }"
            translate
            (click)="addVariable()"
            [disabled]="disableField || isFromModernize"
          >
            {{ 'ADD_VARIABLE' | translate }}
          </button>
        </div>
        <div class="d-flex flex-column">
          <p-table
            [value]="pageVariablesProperty"
            class="fil-map-table"
            [showGridlines]="true"
            [style]="{ width: '100%' }"
            [scrollable]="true"
          >
            <ng-template #header>
              <tr>
                <th>
                  <span class="required">{{ 'VARIABLE_NAME' | translate }}</span>
                </th>
                <th>{{ 'TYPE' | translate }}</th>
                <th>{{ 'DEFAULT_VALUE' | translate }}</th>
                <th></th>
              </tr>
            </ng-template>
            <ng-template #body let-data let-rowIndex="rowIndex">
              <tr [ngClass]="{ 'row-highlight': !data.recordSaved }">
                <td>
                  <div class="d-flex align-items-center">
                    <div class="form-group prop-elems">
                      <input
                        [name]="data.pageVariablesPropertyName"
                        pInputText
                        [pTooltip]="data.pageVariablesPropertyName"
                        tooltipPosition="top"
                        [attr.id]="data.pageVariablesPropertyName"
                        appAlphaNumericUnderscore
                        type="text"
                        class="form-control form-control-sm"
                        maxlength="50"
                        [(ngModel)]="data.pageVariablesPropertyName"
                        (paste)="onPastePVName($event, rowIndex)"
                        (blur)="onNameChange(data.pageVariablesPropertyName, rowIndex)"
                        (keydown.enter)="onNameChange(data.pageVariablesPropertyName, rowIndex)"
                        [disabled]="disableField"
                      />
                    </div>
                  </div>
                </td>
                <td>
                  <div class="d-flex align-items-center pv-type">
                    <p-select
                      [options]="pageVariablesPropertyType"
                      [(ngModel)]="data.pageVariablesPropertyType"
                      optionLabel="name"
                      placeholder="Select"
                      [disabled]="disableField"
                      optionValue="value"
                      (onChange)="onValueChange($event, 'type', rowIndex)"
                      [appendTo]="'body'"
                      class="w-100 pv-select"
                    >
                    </p-select>
                  </div>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <div class="form-group prop-elems w-100">
                      <ng-container [ngSwitch]="data.pageVariablesPropertyType">
                        <ng-template [ngSwitchCase]="'STRING'">
                          <input
                            [name]="data.pageVariablesPropertyName"
                            pInputText
                            [attr.id]="data.pageVariablesPropertyName"
                            type="text"
                            class="form-control form-control-sm"
                            maxlength="60"
                            placeholder="Enter a value"
                            [(ngModel)]="data.pageVariablesPropertyDefaultValue"
                            (blur)="onDefaultValueChange(data.pageVariablesPropertyDefaultValue, rowIndex)"
                            (keydown.enter)="onDefaultValueChange(data.pageVariablesPropertyDefaultValue, rowIndex)"
                            [disabled]="disableField"
                          />
                        </ng-template>
                        <ng-template [ngSwitchCase]="'NUMBER'">
                          <p-inputNumber
                            [(ngModel)]="data.pageVariablesPropertyDefaultValue"
                            [minFractionDigits]="0"
                            [maxFractionDigits]="0"
                            placeholder="Enter a value"
                            inputId="integeronly"
                            class="form-control form-control-sm"
                            [attr.id]="data.pageVariablesPropertyName"
                            (onBlur)="onDefaultValueChange(data.pageVariablesPropertyDefaultValue, rowIndex)"
                            (onKeyDown)="onInputNumberEnterKey($event, data, rowIndex)"
                            [disabled]="disableField"
                          ></p-inputNumber
                        ></ng-template>
                        <ng-template
                          [ngSwitchCase]="
                            ['DATE_ONLY', 'DATE_TIME'].includes(data.pageVariablesPropertyType)
                              ? data.pageVariablesPropertyType
                              : null
                          "
                        >
                          <p-select
                            [options]="pageVariablesPropertyDefaultValDPV"
                            [(ngModel)]="data.pageVariablesPropertyDefaultValue"
                            optionLabel="name"
                            placeholder="Select"
                            [disabled]="disableField"
                            optionValue="value"
                            (onChange)="onValueChange($event, '', rowIndex)"
                            [showClear]="true"
                            [appendTo]="'body'"
                            class="w-100 pv-select"
                          >
                          </p-select
                        ></ng-template>
                        <ng-template [ngSwitchCase]="'DOUBLE'">
                          <p-inputNumber
                            [(ngModel)]="data.pageVariablesPropertyDefaultValue"
                            mode="decimal"
                            inputId="decimalInput"
                            [minFractionDigits]="1"
                            class="form-control form-control-sm"
                            [attr.id]="data.pageVariablesPropertyName"
                            placeholder="Enter a value"
                            (onBlur)="onDefaultValueChange(data.pageVariablesPropertyDefaultValue, rowIndex)"
                            (onKeyDown)="onInputNumberEnterKey($event, data, rowIndex)"
                            [disabled]="disableField"
                          ></p-inputNumber>
                        </ng-template>
                        <ng-template [ngSwitchCase]="'EMAIL'">
                          <input
                            [name]="data.pageVariablesPropertyName"
                            pInputText
                            [attr.id]="data.pageVariablesPropertyName"
                            type="text"
                            class="form-control form-control-sm"
                            placeholder="Enter a value"
                            [(ngModel)]="data.pageVariablesPropertyDefaultValue"
                            (blur)="onDefaultValueChange(data.pageVariablesPropertyDefaultValue, rowIndex)"
                            (keydown.enter)="onDefaultValueChange(data.pageVariablesPropertyDefaultValue, rowIndex)"
                            [disabled]="disableField"
                          />
                        </ng-template>
                        <ng-template [ngSwitchCase]="'BOOLEAN'">
                          <p-select
                            [options]="pageVariablesPropertyDefaultValBoolean"
                            [(ngModel)]="data.pageVariablesPropertyDefaultValue"
                            optionLabel="name"
                            optionValue="value"
                            placeholder="{{ 'SELECT' | translate }}"
                            [disabled]="disableField"
                            (onChange)="onValueChange($event, '', rowIndex)"
                            [appendTo]="'body'"
                            class="w-100 pv-select"
                          >
                          </p-select>
                        </ng-template>
                      </ng-container>
                    </div>
                  </div>
                </td>
                <td class="text-center">
                  <div class="page-variables-actions" *ngIf="!disableField">
                    <svg-icon
                      (click)="data.recordSaved && data.pageVariablesPropertyName && showWhereUsed(rowIndex, data)"
                      [src]="svgPaths.whereUsed.default"
                      class="icon-plus where-used-icon where-used-icon-for-overlay"
                      [ngClass]="{
                        'cursor-pointer': data.recordSaved && data.pageVariablesPropertyName,
                        'disabled-icon': !data.recordSaved || !data.pageVariablesPropertyName
                      }"
                      alt="where used"
                      aria-hidden="true"
                      showDelay="100"
                      hideDelay="100"
                      pTooltip="{{ 'WHERE_USED' | translate }}"
                      tooltipPosition="top"
                    ></svg-icon>
                    <svg-icon
                      (click)="data.recordSaved && data.pageVariablesPropertyName && deletePageVariable(rowIndex, data)"
                      src="assets\images\svg\trash.svg"
                      class="icon-plus"
                      [ngClass]="{
                        'cursor-pointer': data.recordSaved && data.pageVariablesPropertyName,
                        'disabled-icon': !data.recordSaved || !data.pageVariablesPropertyName
                      }"
                      alt="delete"
                      aria-hidden="true"
                      showDelay="100"
                      hideDelay="100"
                      pTooltip="Delete"
                      tooltipPosition="top"
                    ></svg-icon>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template #emptymessage>
              <tr class="no-records">
                <td colspan="3" class="text-center w-100">
                  {{ 'NO_RECORDS_FOUND' | translate }}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</div>
